export default {
      id: "icon--terms-condish-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--terms-condish-usage",
      toString: function () {
        return this.url;
      }
    }